
jQuery(function($) {

  //  ///////////  //
  //  JS : GALERIE D'IMAGE  //
  //  ///////////  //
  $("#lightgallery").lightGallery({
       subHtmlSelectorRelative: true
  }); 



  $(".wysiwyg .gallery").lightGallery({
      selector:'a',
      subHtmlSelectorRelative: true
  }); 




     //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();



   
    //alert('a'); // comprends pas pourquoi on voit deux fois ce message.


    ////////////////////////
    ///// VAR ////////////
    /////////////////////

    var $dest_sub_menu, l_window, $active_menu,LARGEUR_MAX_MOBILE;
    l_window = parseInt($(window).width());
    LARGEUR_MAX_MOBILE = 1023;
    var header = $('#masthead');
    
    /* Transition des pages */
    $('.header-sub-link, #footer-menu a, .OtherPage a, .link_espace_adherent').click(function(e){
        $('body').addClass('to_transition_page');

        var link = $(this).attr("href");
        setTimeout(function() {
            window.location.href = link;
        },300);
        e.preventDefault();
    });



     // $('.link_espace_adherent').click(function(e){
     //   $('body').addClass('to_transition_adherent');
     //    var link = $(this).attr("href");
     //    setTimeout(function() {
     //        window.location.href = link;
     //    }, 300);

     //    e.preventDefault();

     // });

    
    /*************/
    /* CLICK SUR BTN ESPACE ADHERENT = TRANSITION VERS PAGE = ATTENTE EN JS */
    /*************/


   /*************/
    /* OUVERTURE / FERMETURE DU MENU */
    /*************/
    $('.menu-toggle').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
           $(this).find('.txt').text('Fermer');
           $active_menu = '';
           $dest_sub_menu = $('#smenu-menu');
           active_sub_menu($active_menu, $dest_sub_menu);
           $(this).attr('aria-expanded', "true");
           $("body").addClass('toggled-menu-desktop');

         }else{
            $(this).find('.txt').text('Menu');
            $(this).attr('aria-expanded', "false");
            disable_sub_menu('', $('#smenu-menu'));
           $("body").removeClass('toggled-menu-desktop');
         }
         e.preventDefault();
    });


// FIN VAR ////
    
    $( "#nav-main .container_menu--inner .header-nav-item.toDoHover" ).mouseover(function() {
        $active_menu = $(this);
        $dest_sub_menu = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]'); 
        active_sub_menu($active_menu, $dest_sub_menu);
    });


    $( "#nav-main .container_menu--inner .header-nav-item.toDoHover" ).mouseleave(function(e) {
      console.log('On quitte l\'item');
      if($(e.relatedTarget).parents('.header-subs').length) {
        
      }else{
        disable_sub_menu($active_menu, $dest_sub_menu);
      }
     });

    /// Ajout code pour sortir des sous-menu actif
    $( ".header-sub" ).mouseleave(function(e) {
     disable_sub_menu($active_menu, $dest_sub_menu);
      //if(header_sub_destination.hasClass('active')) disable_sub_menu_dest();
    });


    // Ajout pour fermer le menu si on clique sur le sous-menu avec la croix
    $('body').on('click', ".header-sub.active", function(e) {
        console.log($(e.target));
        console.log($(e.relatedTarget));
    if (!$(e.target).parent().is('a')) {
             disable_sub_menu($active_menu, $dest_sub_menu);
             console.log('here');
              e.stopPropagation();
              e.preventDefault();
        }
      
    });

  function to_reinit_main_menu(){
     $('.menu-toggle').find('.txt').text('Menu');
     $('.menu-toggle').attr('aria-expanded', "false");
     $("body").removeClass('toggled-menu-desktop');
  }
  function active_sub_menu($active_menu,$dest_sub_menu){

     if($('.menu-toggle').attr('aria-expanded') == 'true'){
          disable_sub_menu('', $('#smenu-menu'));
     }
    
    $('#nav-main .container_menu--inner .header-nav-item.toDoHover').removeClass('is-hover');
    $('.header-sub').removeClass('active');
    if($active_menu){
         $active_menu.addClass('is-hover');
    } 
   
    $dest_sub_menu.addClass('active');
  }

  function disable_sub_menu($active_menu,$dest_sub_menu){
     if($active_menu){
      $active_menu.removeClass('is-hover');
     }else{
       to_reinit_main_menu();
     }
    
    $dest_sub_menu.removeClass('active');
   // header.removeClass('bg_for_hover');
  }



  /*  ***************************
    APPARITION DE LA NAV A DROITE
  ******************************** */
   if($(".ClassicPage-Nav").length){
  var pos_blockContent = parseInt($('.ClassicPage-Bottom').position().top);
  var pos_nav = parseInt($('.ClassicPage-Nav').height() / 2);
  var h_header = 111; //$("#masthead").height();
  } 
 //pos_nav sert a tchi
  function to_appaer_nav(){

    if ($(window).scrollTop() > (pos_blockContent - h_header - pos_nav)){
        $('.ClassicPage-Nav').addClass('visible');
    }else{
        $('.ClassicPage-Nav').removeClass('visible');
    }

  }


   $( window ).resize(function() {
      if($(".ClassicPage-Nav").length){
       h_header = $("#masthead").height();
       pos_blockContent = parseInt($('.ClassicPage-Bottom').position().top);
       pos_nav = parseInt($('.ClassicPage-Nav').height() / 2);
     }
   });


       // Cache selectors
  var lastId,
      topMenu = $("#masthead"),
      $SubMenuLink = $("#sub_menu"),
      topMenuHeight = topMenu.outerHeight()+15,
      // All list menuItems
      menuItems = $SubMenuLink.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) {return item;}
      });
   
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href");
    var variable = 0;
        var offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500);
        
     
      e.preventDefault();
  });

    // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 10;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "section_1";
      
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='#"+id+"']").addClass("active");
     }else{
      // console.log('here' + id);
      // menuItems.filter("a[href='#section_1']").addClass("active");
     }                 
  });


  var other_link =  $('.link_to_scroll, .btn-loupe > a');
  other_link.click(function(e){
    
    var href = $(this).attr("href");

    if(href.indexOf('/') !== -1){
      var array_href = href.split(/[/]/);
      href = array_href[array_href.length-1];
   }
      
        var offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+59; // difference entre menu ouvert et fermé... 44 + 15 
      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 500);
      e.preventDefault();
  });



  /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
      action_on_scroll();
      if($(".ClassicPage-Nav").length){
        to_appaer_nav();
      }
    });

    function action_on_scroll(){

      l_window = parseInt($(window).width());
      h_header = $("#masthead").height();

      if (l_window > LARGEUR_MAX_MOBILE){
         if ($(window).scrollTop() > h_header - 30){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
          }else{
                header.removeClass("Masthead--sticky");
              $("body").removeClass('header--sticky');
          }
      }
   }





    /* *****************  */
    /* ACCORDEON // Nottament pour la partie : Mon compte : documnet
  /* *****************  */

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.AccordeonBloc .accordion-section-title').removeClass('active');
        $('.AccordeonBloc .accordion-section-content').slideUp(300).removeClass('open');
        $('.AccordeonBloc .Acc-Item_img').slideUp(300);
    }

    function init_accordeon(){
      $('.accordion-section-content').hide();
      //$('.accordion-section-content').parent().addClass('active');
    }
    init_accordeon();

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
      
         $('.accordion-section-content[data-id!="'+currentAttrValue+'"]').slideUp(300);
         $('.accordion-section-content[data-id!="'+currentAttrValue+'"]').parent().removeClass('active'); 

          
        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordion-section-content[data-id="'+currentAttrValue+'"]').slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

           // $('.Acc-Item_img[data-id="'+currentAttrValue+'"]').slideUp(300).removeClass('open'); 

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordion-section-content[data-id="'+currentAttrValue+'"]').slideDown(300).addClass('open'); 
            
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////






  // FORM CONTACT LABEL ///
   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textare" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



 });